import React from 'react'
import ContactForm from './ContactForm'

const Contact = () => {
  return (
    <div className='contact mt-3 bg-dark pb-3'>
          <ContactForm />
    </div>
  )
}
 
export default Contact